module.exports = __webpack_public_path__ + "img/upload_2.fc144624.svg";